import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import dynamic from 'next/dynamic'

import { useRouter } from 'next/router'

import styles from './style.module.scss'
import noImage from '@assets/images/placeholder/article-placeholder.jpg'
import { getImgURL, checkPageNumberInSlug } from '@shared-submodule/utils'
import { BLUR_DATA_URL_BASE64, WIDGET } from '@shared-submodule/sm-constants'
import Layout from '../layout'
import MyImage from '@shared/components/myImage'
import AllWidget from '@shared/components/allWidget'
import BreadcrumbNav from '@shared/components/breadcrumbNav'
import TrendingNewsArticle from '../trandingNewsArticle'
import LiveBlog from '../liveArticle/liveBlogTimeLine'
import StaticBanner from '../staticBanner'
import useWindowSize from '@shared/hooks/windowSize'
import TopTennisPlayers from '../widgets/topTennisPlayers'
import { reviveAdData } from '@shared/components/reviveAds/reviveAdData'
import ArticleActions from '../article/articleActions'
import PopularVideos from './popular-videos'

// const GoogleAds = dynamic(() => import('@shared-submodule/sm-components/googleAds'), { ssr: false })
const TopTeams = dynamic(() => import('@shared/components/widgets/topTeams'), { ssr: false })
const TrendingSeries = dynamic(() => import('@shared/components/widgets/trendingSeries'), { ssr: false })
const ExclusiveIcon = dynamic(() => import('@shared/components/ctIcons/exclusiveIcon'), { ssr: false })
const EditorsPickIcon = dynamic(() => import('@shared/components/ctIcons/editorsPickIcon'), { ssr: false })
const LazyLoad = dynamic(() => import('@shared/components/lazyLoad'), { ssr: false })
// const DownloadApp = dynamic(() => import('@shared/components/downloadApp'))
const Comments = dynamic(() => import('@shared/components/comments'))
const OnMouseAndScroll = dynamic(() => import('@shared/components/lazyLoad/onMouseAndScroll'))
const ATSAds = dynamic(() => import('@shared/components/atsAds'), { ssr: false })
const ReviveAds = dynamic(() => import('@shared/components/reviveAds'), { ssr: false })
function ArticleDetail({ article, isPreviewMode, seoData, children, type, liveArticle }) {
  const router = useRouter()
  const [width] = useWindowSize()
  const isFootball = router?.asPath?.startsWith('/football-news/')
  const isTennis = router?.asPath?.startsWith('/tennis-news/')

  const [page, setPage] = useState(1)
  const [commentCount, setCommentCount] = useState(article?.nCommentCount || 0)

  useEffect(() => {
    const slug = router?.asPath?.split('/').filter(e => e)
    const { lastSlug } = checkPageNumberInSlug(slug)
    setPage(lastSlug ? Number(lastSlug) || 1 : 1)
  }, [router?.asPath])

  const { addRight, addLeft, addBottom, add300 } = reviveAdData

  return (
    <Layout data={{ ...article, oSeo: { ...article?.oSeo, ...seoData } }} isPreviewMode={isPreviewMode}>
      {/* <ChessPopAdMweb /> */}
      <main className={`${styles.articlePage}`}>
        <section className={`common-section ${type === 'fantasyArticle' ? 'pt-3' : 'pt-3 pt-md-4'}`}>
          <ATSAds />
          <div className="container">
            <div className="row justify-content-center justify-content-lg-start">
              <div className="col-lg-3 common-sidebar bt-width isDesk">
                {!isPreviewMode && (
                  <>
                    {/* <StaticBannerSecond adType="secondAd_Rect" link="article_left_banner" /> */}
                    <LazyLoad>
                      {isFootball ? <TrendingNewsArticle /> : <TrendingNewsArticle />}
                    </LazyLoad>
                  </>
                )}
                <ReviveAds {...addRight} className={'d-flex justify-content-center mb-4 sticky_ads'} />
              </div>
              <div className="col-lg-6">
                <section className={`${styles.articleBlock} pb-2 mb-2 pt-0 position-relative`}>
                  <div
                    className={`d-flex align-items-start justify-content-between ${
                      article?.oAdvanceFeature?.bEditorsPick && article?.oAdvanceFeature?.bExclusiveArticle && 'flex-column flex-sm-row'
                    }`}>
                    {!isPreviewMode && <BreadcrumbNav listicleCurrentPage={page} checkExternalRoutes />}
                    <div className="d-flex mb-2 mb-md-0">
                      {article?.oAdvanceFeature?.bEditorsPick && (
                        <span className={`badge bg-light" ${styles.advFeature} d-flex align-items-center text-capitalize`}>
                          <EditorsPickIcon />
                          {"Editor's Pick"}
                        </span>
                      )}
                      {article?.oAdvanceFeature?.bExclusiveArticle && (
                        <span className={`badge bg-light" ${styles.advFeature} d-flex align-items-center text-capitalize ms-2`}>
                          <ExclusiveIcon />
                          {'Exclusive Article'}
                        </span>
                      )}
                    </div>
                    {article?._id === '63a40babfdaa420306916fd6' && <p className={`text-danger ${styles.liveUpdate}`}>LIVE</p>}
                  </div>

                  <article>
                    {/* <h1 className={`${styles.title}`}>{article?.sTitle}</h1> */}
                    {/* <div className={`${styles.authorBlock} d-flex flex-wrap align-items-center mb-3 mb-lg-4 mt-1`}> */}
                    {/* {article.iEventId ? (
                        <span className={`${styles.liveblog} text-uppercase d-none d-sm-block position-relative me-4 `}>
                          {"Live Blog"}
                        </span>
                      ) : null} */}
                    {/* {article.iEventId ? (
                        <span className={`${styles.liveblog} text-uppercase d-sm-none position-relative me-4 `}>
                          {"Live Blog"}
                        </span>
                      ) : null} */}
                    {/* </div> */}
                    <h1 className={styles.hOveride}>{article?.sTitle}</h1>
                    {page <= 1 && (
                      <figure className="op-tracker">
                        <div className={`${styles.postImg} position-relative overflow-hidden`}>
                          <MyImage
                            priority={true}
                            src={getImgURL(article?.oImg?.sUrl) || noImage}
                            alt={article?.oImg?.sText || article?.sSrtTitle}
                            placeholder="blur"
                            blurDataURL={BLUR_DATA_URL_BASE64}
                            height="160"
                            width="256"
                            layout="responsive"
                            sizes="(max-width: 767px) 320px, (max-width: 991px) 360px, (max-width: 1190px) 400px, 600px"
                          />
                          <div className={`${styles.titleContent} d-flex justify-content-between align-items-start w-100`}>
                            {article?.oImg?.sCaption !== 'null' && (
                              <figcaption className={`${styles.caption}`} dangerouslySetInnerHTML={{ __html: article?.oImg?.sCaption }} />
                            )}

                            {!isPreviewMode && <ArticleActions article={article} type={type} seoData={seoData} />}
                          </div>
                        </div>
                      </figure>
                    )}
                    {children}
                  </article>
                  {/* <StaticBannerSecond adType="secondAd_long" link="article_bottom_banner" /> */}
                  {/* <div className='d-md-none'>
                    <StaticBannerSecond adType='secondAdRect_Left' link='article_mweb_bottom_banner'/>
                  </div> */}
                  <div className="d-flex justify-content-center d-md-none">
                    <ReviveAds {...addLeft} className={'mb-4'} />
                  </div>
                  {article?.oAdvanceFeature?.bAllowComments && (
                    <OnMouseAndScroll>
                      <Comments
                        type={type}
                        commentCount={commentCount}
                        setCommentCount={setCommentCount}
                        articleId={article?._id}
                        count={article?.nCommentCount}
                        isRequireAdminApproval={article?.oAdvanceFeature?.bRequireAdminApproval}
                      />
                    </OnMouseAndScroll>
                  )}
                  <div className="d-none d-md-block mt-4">
                    <PopularVideos />
                  </div>
                  {width > 991 && <ReviveAds {...addBottom} className={'mt-4 mb-4'} />}
                  <OnMouseAndScroll>
                    <div className="d-md-none">
                      <TrendingNewsArticle ePlatform={isFootball ? 'f' : ''} />
                    </div>
                  </OnMouseAndScroll>
                  <div className="d-md-none">
                    <StaticBanner isLeft />
                  </div>
                  {/* <OnMouseAndScroll> */}
                  {/* <DownloadApp isArticle isDesk /> */}
                  {/* </OnMouseAndScroll> */}
                </section>
                {/* Desktop/Mobile above related Video and article  */}
                {/* <div ref={observe}>
                  {(!isPreviewMode && inView) && (
                    <> */}
                {/* {(width < 768) && <PixFuture />} */}
                {/* {(width > 768 && (article?.oCategory?._id || article?.iCategoryId)) && (
                        <ArticleRelatedVideos categoryId={article?.oCategory?._id || article?.iCategoryId} articleId={article?._id} type={article?.oSeo?.eType} />
                      )} */}
                {/* <ErrorBoundary>
                        <TaboolaAds />
                      </ErrorBoundary> */}
                {/* </>
                  )}
                </div> */}
              </div>
              <div className="col-lg-3 common-sidebar bt-width isDesk">
                {!isPreviewMode && (
                  <>
                    {article?.iEventId ? (
                      <LiveBlog data={liveArticle} />
                    ) : (
                      <>
                        <StaticBanner isLeft />
                        <LazyLoad>
                          {isFootball ? (
                            <>
                              <TopTeams ePlatform={isFootball ? 'f' : ''} />
                              <TrendingSeries />
                              <ReviveAds {...addRight} className={'my-3 sticky_ads'} />
                            </>
                          ) : isTennis ? (
                            <>
                              <TopTennisPlayers />
                              <ReviveAds {...addRight} className={'my-3 sticky_ads'} />
                            </>
                          ) : (
                            <>
                              <AllWidget type={WIDGET.upcomingMatches} show />
                              <ReviveAds {...addRight} className={'mb-4'} />
                              <AllWidget type={WIDGET.topTeams} show />
                              <ReviveAds {...add300} className={'mb-4'} />
                              <AllWidget type={WIDGET.trendingPlayers} show />
                            </>
                          )}
                        </LazyLoad>
                        <ATSAds />
                      </>
                    )}
                  </>
                )}
              </div>
            </div>
          </div>
        </section>
      </main>
    </Layout>
  )
}

ArticleDetail.propTypes = {
  article: PropTypes.object,
  liveArticle: PropTypes.object,
  seoData: PropTypes.object,
  isPreviewMode: PropTypes.bool,
  children: PropTypes.node.isRequired,
  type: PropTypes.string
}

export default ArticleDetail
